import React from 'react'
import Select from "react-select";

const errorSelectStyles = {
    control: (base, state) => ({
        ...base,
        borderColor: state.selectProps.hasError ? "#dc3545" : base.borderColor,
        "&:hover": {
            borderColor: state.selectProps.hasError ? "#dc3545" : base.borderColor,
        },
    }),
};

const CostAllocation = ({ rows = [], onChange, onTickChange,onFileDownload, onFileUpload, onFileDelete, errors = {}, isDisabled }) => {
    return (
        <>
            <div className="cost-allocation-list member-list">
                <div className="content-section">
                    <div className="table-section">
                        <table>
                            <thead>
                                <tr>
                                    <th>Cert Number</th>
                                    <th>Item Code</th>
                                    <th>Tick Rating</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {rows.map((row) => {
                                    const rowErrors = errors[row.id] || {};
                                    const hasItemCodeError = Boolean(rowErrors.itemCode);
                                    const hasTickError = Boolean(rowErrors.tickRating);
                                    const hasFileError = Boolean(rowErrors.file);

                                    return (
                                        <tr key={row.id}>
                                            <td>{row.label} <span className="text-danger">*</span></td>

                                            <td>
                                                <div className="form-group">
                                                    <Select
                                                        className="custom-checkbox-select"
                                                        value={row.value}
                                                        options={row.options}
                                                        onChange={(selected) => onChange?.(row.id, selected)}
                                                        isMulti={row.isMultiSelect ?? false}
                                                        placeholder={row.placeholder ?? "Select"}
                                                        styles={errorSelectStyles}
                                                        hasError={hasItemCodeError}
                                                        isDisabled={isDisabled}
                                                    />
                                                    {hasItemCodeError && (
                                                        <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                                                            {rowErrors.itemCode}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>

                                            <td>
                                                <div className="form-group">
                                                    <Select
                                                        className="custom-checkbox-select"
                                                        value={row.tickValue}
                                                        options={row.tickOptions}
                                                        onChange={(selected) => onTickChange?.(row.id, selected)}
                                                        placeholder="Select"
                                                        isDisabled={isDisabled}
                                                        hasError={hasTickError}
                                                        styles={errorSelectStyles}
                                                    />
                                                    {hasTickError && (
                                                        <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                                                            {rowErrors.tickRating}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>

                                            {/* Actions - File Upload / Delete (UI dev original styling) */}
                                            <td>
                                                <div className="form-group">
                                                    <div className="file-upload-wrapper d-flex align-items-center gap-2">
                                                        <input
                                                            type="file"
                                                            id={`file-input-${row.id}`}
                                                            className="certificate-file-input"
                                                            accept=".xls,.xlsx,.xlsm"
                                                            style={{ display: "none" }}
                                                            disabled={isDisabled}
                                                            onChange={(e) => {
                                                                const file = e.target.files?.[0];
                                                                if (file) onFileUpload?.(row.id, file);
                                                                e.target.value = "";
                                                            }}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-success success-btn d-flex align-items-center justify-content-center"
                                                            style={{
                                                                backgroundColor: "#2e8b00",
                                                                borderColor: "#2e8b00",
                                                                color: "#fff",
                                                                padding: "6px 16px",
                                                                borderRadius: "4px",
                                                                fontSize: "14px",
                                                                fontWeight: "600",
                                                                border: "none",
                                                                cursor: isDisabled ? "not-allowed" : "pointer",
                                                                opacity: isDisabled ? 0.6 : 1,
                                                            }}
                                                            disabled={isDisabled}
                                                            onClick={() => document.getElementById(`file-input-${row.id}`).click()}
                                                        >
                                                            Upload
                                                        </button>
                                                        {/* {row.certificateFileName && (
                                                            <div className="d-flex align-items-center gap-1 ms-2" style={{ minWidth: 0 }}>
                                                                <a
                                                                    href={row.certificateFilePath || "#"}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    title={row.certificateFileName}
                                                                    style={{
                                                                        color: "#2e8b00",
                                                                        fontWeight: "600",
                                                                        fontSize: "14px",
                                                                        textDecoration: "underline",
                                                                        maxWidth: "150px",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        display: "inline-block",
                                                                        verticalAlign: "middle"
                                                                    }}
                                                                >
                                                                    {row?.certificateFileName}
                                                                </a>
                                                                {!isDisabled && (
                                                                    <i
                                                                        className="bi bi-x-circle"
                                                                        style={{
                                                                            color: "#2e8b00",
                                                                            cursor: "pointer",
                                                                            fontSize: "16px",
                                                                            marginLeft: "4px",
                                                                            display: "inline-flex",
                                                                            alignItems: "center"
                                                                        }}
                                                                        onClick={() => onFileDelete?.(row.id)}
                                                                        title="Remove file"
                                                                    ></i>
                                                                )}
                                                            </div>
                                                        )} */}
                                                        {row.certificateFileName && (
                                                            <div className="d-flex align-items-center gap-1 ms-2" style={{ minWidth: 0 }}>
                                                                <span
                                                                    role="button"
                                                                    tabIndex={0}
                                                                    title={row?.certificateFileName}
                                                                    onClick={() => onFileDownload?.(row)}
                                                                    style={{
                                                                        // color: isDisabled ? "#6c757d" : "#2e8b00",
                                                                        color: "#2e8b00",
                                                                        fontWeight: "600",
                                                                        fontSize: "14px",
                                                                        // textDecoration: isDisabled ? "none" : "underline",
                                                                        textDecoration: "underline",
                                                                        maxWidth: "150px",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        display: "inline-block",
                                                                        verticalAlign: "middle",
                                                                        // cursor: isDisabled ? "default" : "pointer",
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    {row.certificateFileName}
                                                                </span>
                                                                {!isDisabled && (
                                                                    <i
                                                                        className="bi bi-x-circle"
                                                                        style={{
                                                                            color: "#2e8b00",
                                                                            cursor: "pointer",
                                                                            fontSize: "16px",
                                                                            marginLeft: "4px",
                                                                            display: "inline-flex",
                                                                            alignItems: "center"
                                                                        }}
                                                                        onClick={() => onFileDelete?.(row.id)}
                                                                        title="Remove file"
                                                                    ></i>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {hasFileError && (
                                                        <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                                                            {rowErrors.file}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}

                                {rows.length === 0 && (
                                    <tr>
                                        <td colSpan={4}>No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CostAllocation;